import React from 'react'

import LtiApplyTheme from './LtiApplyTheme'
import LaunchRetriever from './LaunchRetriever'
import ContentItemForm from "./ContentItemForm";
import {Flex} from "@instructure/ui-flex";
import SearchExperience from "./Search";

const settings = {
    'https://localhost:3000': {
        'ltiServer': process.env.REACT_APP_LTI_URL
    },
    'https://giphy.wyelearning.com': {
        'ltiServer': 'https://lti.wyelearning.com'
    }
}

class App extends React.Component {
    state = {
        jwt: null,
        needsToken: false,
        error: null,
        brandConfig: undefined,
        returnUrl: null,
        selection: undefined,
        // Should we replace everything in the RCE?
        updateAll: false,
        highContrast: false,
        data: "",
        css: undefined,
        development: process.env.NODE_ENV !== 'production',
        language: null,
        // The content items we are passing back
        contentItems: null
    }

    constructor(props) {
        super(props)
        const origin = window.origin
        if (settings[origin]) {
            this.server = settings[origin].ltiServer
        }
    }

    cssVariableUrl = (data) => {
        // There isn't a variable for the css URL but the json url is in the same place.
        const jsonUrl = data.custom_brand_config[0]
        if (jsonUrl && jsonUrl.endsWith(".json")) {
            return jsonUrl.slice(0, -5) + ".css"
        }
    }

    updateData = async (data) => {
        let selection = data.custom_selection[0]
        // If there isn't any selection is sends through the unexpanded variable (although this seems to have changed)
        if (selection === '$com.instructure.Editor.selection' || selection === '') {
            selection = undefined
        }
        let contents = data.custom_contents[0]
        if (contents === '$com.instructure.Editor.contents' || contents === '') {
            contents = undefined
        }
        let updateAll = false;
        // If the user hasn't selected anything the update everything in the editor.
        if (!selection && contents) {
            selection = contents;
            updateAll = true;
        }

        return this.setState({
            brandConfig: data.custom_brand_config[0],
            highContrast: data.custom_high_contrast[0] === 'true',
            selection: selection,
            updateAll: updateAll,
            returnUrl: data.content_item_return_url[0],
            data: data.data[0],
            css: data.custom_canvas_css[0],
            cssVariables: this.cssVariableUrl(data),
            // if there's a development custom variable or we're in development mode.
            development: data.custom_development || this.state.development,
        })
    }
    makeContentItem = (html, updateAll = false) => {
        // Don't return anything if empty
        let item = []
        if (html.length > 0) {
            item.push({
                // This can also be 'lti_replace' for replacing the contents of the rich text editor.
                '@type': updateAll ? 'lti_replace' : 'ContentItem',
                'mediaType': 'text/html',
                'text': html,
                'placementAdvice': {
                    'presentationDocumentTarget': 'embed'
                }
            })
        }
        return {
            '@context': 'http://purl.imsglobal.org/ctx/lti/v1/ContentItem',
            '@graph': item
        }
    }

    handleRef = (ref) => {
        this.form = ref
    }

    onGifClick = (gif) => {
        if (this.state.returnUrl) {
            const html = `<picture>
            <source srcset="${gif.images.original.webp}" type="image/webp" />
            <img src="${gif.images.original.url}" alt="${gif.title}" width="${gif.images.original.width}" height="${gif.images.original.height}" />
        </picture>`
            this.setState({
                contentItems: JSON.stringify(this.makeContentItem(html))
                // We don't send back a message as it delays the insertion into Canvas.
            }, () => this.form.submit())
        } else {
            alert(`Not launched from Canvas so can't add GIF.\nSelected: ${gif.title}`)
        }
    }

    render() {

        return (
            <LaunchRetriever ltiServer={this.server} handleData={this.updateData}>
                <LtiApplyTheme url={this.state.brandConfig} highContrast={this.state.highContrast}>
                    <Flex direction='column' height='100%'>
                        <Flex.Item shouldGrow shouldShrink overflowX='hidden'>
                            <SearchExperience onGifClick={this.onGifClick}/>
                        </Flex.Item>
                    </Flex>
                    <ContentItemForm data={this.state.data} elementRef={this.handleRef} returnUrl={this.state.returnUrl}
                                     contentItems={this.state.contentItems}/>
                </LtiApplyTheme>
            </LaunchRetriever>
        )
    }
}

export default App
